module.exports = __webpack_public_path__ + "static/media/menuHamburgerClose.b1f834d7.svg";